module.exports = __webpack_public_path__ + "img/icon-star-light.1552a036.svg";